export const strJoin = (delimeter, ...params) => {
  let result = ''
  for (let i = 0; i < params.length; i++) {
    if (i > 0) {
      result += delimeter
    }
    result += params[i] === null || params[i] === undefined ? '' : params[i]
  }
  return result
}

export const checkNull = (value) => {
  if (value === null || value === undefined || value === '') {
    return ''
  }
  return value
}
